import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      sessionStorage.getItem('token') &&
      sessionStorage.getItem('role') == 'ADMIN' &&
      sessionStorage.getItem('enable') == 'true'
    ) {
      return true;
    } else {
      this.router.navigate(['/authentication']);
      sessionStorage.clear();
      localStorage.removeItem('me');
      return false;
    }
  }
}
